import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import { Button } from "reactstrap";
import Datetime from "react-datetime";

const ButtonTw = tw(Button)`px-8 py-3 font-bold rounded bg-primary-500 text-gray-100 hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline focus:outline-none transition duration-300 mt-12 inline-block tracking-wide text-center px-10 py-4 font-semibold tracking-normal`;
const Calendar = tw(Datetime)`text-blue-400`;

const FilterByDates = ({ selectedDateStart, setSelectedDateStart, selectedDateEnd, setSelectedDateEnd }) => (
  <div style={{ marginBottom: '1.5rem', display: 'flex', gap: '1rem', alignItems: 'flex-end' }}>
    <div style={{ flex: 1 }}>
      <label htmlFor="datePickerStart" style={{ fontWeight: 'bold', color: '#fff', marginBottom: 4, display: 'block' }}>Fecha Inicio</label>
      <Calendar
        id="datePickerStart"
        name="datePickerStart"
        key={selectedDateStart ? selectedDateStart.valueOf() : 'empty'}
        value={selectedDateStart}
        timeFormat={false}
        onChange={date => {
          if (date?._isAMomentObject) {
            setSelectedDateStart(date);
          } else {
            setSelectedDateStart(null);
          }
        }}
        inputProps={{
          placeholder: 'Fecha Ini.',
          style: {
            width: '100%',
            padding: '8px',
            borderRadius: '4px',
            border: '1px solid #b3c2d4',
            fontSize: '1rem',
            color: '#333',
            background: '#eaf3fa'
          }
        }}
      />
    </div>
    <div style={{ flex: 1 }}>
      <label htmlFor="datePickerEnd" style={{ fontWeight: 'bold', color: '#fff', marginBottom: 4, display: 'block' }}>Fecha Fin</label>
      <Calendar
        id="datePickerEnd"
        name="datePickerEnd"
        key={selectedDateEnd ? selectedDateEnd.valueOf() : 'empty'}
        value={selectedDateEnd}
        timeFormat={false}
        onChange={date => {
          if (date?._isAMomentObject) {
            setSelectedDateEnd(date);
          } else {
            setSelectedDateEnd(null);
          }
        }}
        inputProps={{
          placeholder: 'Fecha Fin',
          style: {
            width: '100%',
            padding: '8px',
            borderRadius: '4px',
            border: '1px solid #b3c2d4',
            fontSize: '1rem',
            color: '#333',
            background: '#eaf3fa'
          }
        }}
      />
    </div>
    <ButtonTw
      type="button"
      style={{
        height: '44px',
        marginLeft: '1rem',
        marginBottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 10
      }}
      onClick={() => { setSelectedDateStart(null); setSelectedDateEnd(null); }}
    >
      Limpiar
    </ButtonTw>
  </div>
);

FilterByDates.propTypes = {
  selectedDateStart: PropTypes.any,
  setSelectedDateStart: PropTypes.func.isRequired,
  selectedDateEnd: PropTypes.any,
  setSelectedDateEnd: PropTypes.func.isRequired
};

export default FilterByDates;
